<span #optionLabel class="block truncate" [innerHTML]="label() ?? ''" [tooltip]="label() ?? ''"></span>
